module.exports = __webpack_public_path__ + "img/LevelNext_Fifa_22_white.f85d541d.png";